import React, { useState, useRef } from 'react';
import { Modal, Button, SelectProps } from 'antd';

import StyledSelect from '@shared/components/StyledSelect';
import {
  ModalContainer,
  ModalTitle,
  FormSection,
  DropdownContainer,
  ButtonContainer,
} from './styled';

interface GenerateJourneyModalProps {
  visible: boolean;
  onClose: () => void;
  onGenerate?: (selectedEventId: string) => void;
  eventOptions: { label: React.ReactNode; value: string; name?: string }[];
}

const GenerateJourneyModal: React.FC<GenerateJourneyModalProps> = ({
  visible,
  onClose,
  onGenerate,
  eventOptions,
}) => {
  const modalContentRef = useRef<HTMLDivElement>(null);
  const [selectedEvent, setSelectedEvent] = useState<string | undefined>(undefined);

  const isGenerateDisabled = !selectedEvent;

  const handleEventChange = (values: string | string[]) => {
    // StyledSelect can return string or string[], but we only expect single selection
    const value = Array.isArray(values) ? values[0] : values;
    setSelectedEvent(value);
  };

  const handleGenerate = (e) => {
    e.stopPropagation();
    if (onGenerate && selectedEvent) {
      onGenerate(selectedEvent);
    }
  };

  const handleClose = () => {
    setSelectedEvent(undefined);
    onClose();
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={handleClose}
      footer={null}
      closable={false}
      width={520}
      centered
      mask={false}
      maskClosable={true}
      style={{ marginTop: '-150px' }}
      destroyOnClose
    >
      <ModalContainer ref={modalContentRef} as="div" onClick={(e) => e.stopPropagation()}>
        <ModalTitle>Generate Paths For</ModalTitle>

        <FormSection>
          <DropdownContainer>
            <StyledSelect
              label="Milestone Event:"
              placeholder=""
              selectedValues={selectedEvent ? [selectedEvent] : []}
              onChange={handleEventChange}
              valueOptions={eventOptions}
              mode="single"
              allowClear
              getPopupContainer={() => modalContentRef.current || document.body}
            />
          </DropdownContainer>
        </FormSection>

        <ButtonContainer>
          <Button
            type="primary"
            size="large"
            disabled={isGenerateDisabled}
            onClick={handleGenerate}
          >
            Generate Paths
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  );
};

export default GenerateJourneyModal;
